import { Route } from '@angular/router';
import {
  AuthGuard,
  CountriesResolver,
  LanguagesResolver,
  TimezonesResolver,
} from '@ubie/core';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'installations',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'registration',
    resolve: { countries: CountriesResolver, languages: LanguagesResolver },
    loadComponent: () =>
      import('./login/registration/registration.page').then(
        (m) => m.RegistrationPage,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./login/forgot-password/forgot-password.page').then(
        (m) => m.ForgotPasswordPage,
      ),
  },
  {
    path: 'dashboard',
    redirectTo: 'installations',
    pathMatch: 'full',
  },
  // dashboard route kept for future use
  // {
  //   path: 'dashboard',
  //   canActivate: [AuthGuard],
  //   data: {
  //     claimType: ['CanAccessDashboardManaged', 'CanAccessAdminDashboardAll'],
  //   },
  //   loadComponent: () =>
  //     import('./dashboard/dashboard.page').then((m) => m.DashboardPage),
  // },
  {
    path: 'account',
    canActivate: [AuthGuard],
    data: { claimType: ['CanUpdateAccountOwned', 'CanAccessAccountOwned'] },
    resolve: { countries: CountriesResolver, languages: LanguagesResolver },
    loadComponent: () =>
      import('./account/account-info/account-info.page').then(
        (m) => m.AccountInfoPage,
      ),
  },
  {
    path: 'activation/:activationKey',
    loadComponent: () =>
      import('./activation/activation.page').then((m) => m.ActivationPage),
  },
  {
    path: 'licenses',
    canActivate: [AuthGuard],
    data: { claimType: ['CanAccessAccountOwned'] },
    loadComponent: () =>
      import('./licenses/licenses.page').then((m) => m.LicensesPage),
  },
  {
    path: 'purchases',
    canActivate: [AuthGuard],
    data: { claimType: ['CanAccessAccountOwned'] },
    loadComponent: () =>
      import('./account/purchases/purchases.page').then((m) => m.PurchasesPage),
  },
  {
    path: 'password',
    canActivate: [AuthGuard],
    data: { claimType: ['CanUpdateAccountOwned'] },
    loadComponent: () =>
      import('./account/password/password.page').then((m) => m.PasswordPage),
  },
  {
    path: 'installations',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsManaged', 'CanAccessInstallationsAll'],
    },
    loadComponent: () =>
      import('./installations/installations/installations.page').then(
        (m) => m.InstallationsPage,
      ),
  },
  {
    path: 'installation/:installationId/detail',
    redirectTo: 'installation/:installationId/status',
  },
  {
    path: 'installation/:installationId/devices',
    redirectTo: 'installation/:installationId/status',
  },
  {
    path: 'installation/:installationId/owner',
    redirectTo: 'installation/:installationId/status',
  },
  {
    path: 'installation/:installationId/license',
    redirectTo: 'installation/:installationId/status',
  },
  {
    path: 'installation/:installationId/installers',
    redirectTo: 'installation/:installationId/status',
  },
  {
    path: 'installation/:installationId/status',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },
    resolve: { timezones: TimezonesResolver },
    loadComponent: () =>
      import(
        './installations/installation-status/installation-status.page'
      ).then((m) => m.InstallationStatusPage),
  },
  {
    path: 'installation/:installationId/devices-2',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },
    resolve: { timezones: TimezonesResolver },
    loadComponent: () =>
      import(
        './installations/installation-devices-2/installation-devices-2.page'
      ).then((m) => m.InstallationDevices2Page),
  },
  {
    path: 'installation/:installationId/device/:deviceId',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },
    resolve: { timezones: TimezonesResolver },
    loadComponent: () =>
      import(
        './installations/installation-device-detail/installation-device-detail.page'
      ).then((m) => m.InstallationDeviceDetailPage),
  },
  {
    path: 'installation/:installationId/general-info-2',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },
    resolve: { countries: CountriesResolver, timezones: TimezonesResolver },
    loadComponent: () =>
      import(
        './installations/installation-general-info-2/installation-general-info-2.page'
      ).then((m) => m.InstallationGeneralInfo2Page),
  },
  {
    path: 'installation-add',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAddInstallationAll', 'CanAddInstallationManaged'],
    },
    resolve: { countries: CountriesResolver, timezones: TimezonesResolver },
    loadComponent: () =>
      import('./installations/installation-add/installation-add.page').then(
        (m) => m.InstallationAddPage,
      ),
  },
  {
    path: 'installation/:installationId/device/:deviceId',
    canActivate: [AuthGuard],
    data: {
      claimType: ['CanAccessInstallationsAll', 'CanAccessInstallationsManaged'],
    },

    loadComponent: () =>
      import(
        './installations/installation-device/installation-device.page'
      ).then((m) => m.InstallationDevicePage),
  },
  {
    path: 'order/:orderNo/status',
    canActivate: [AuthGuard],
    data: { claimType: ['CanAccessAccountOwned'] },
    loadComponent: () =>
      import('./order-status/order-status.page').then((p) => p.OrderStatusPage),
  },
  {
    path: 'installation/:installationId/accept/installer',
    canActivate: [AuthGuard],
    data: { claimType: ['CanAccessDashboardManaged'] },
    loadComponent: () =>
      import(
        './installations/installation-accept/installation-accept.page'
      ).then((m) => m.InstallationAcceptPage),
  },
];
